var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 390.206 390.206",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M369.067,72.081v51.523H21.657V72.081c0-5.43,4.331-9.762,9.762-9.762h25.988v29.802 c0,5.947,4.848,10.861,10.861,10.861c5.947,0,10.861-4.848,10.861-10.861V62.319h31.418v29.802c0,5.947,4.848,10.861,10.861,10.861 c5.947,0,10.861-4.848,10.861-10.861V62.319h126.255v29.802c0,5.947,4.848,10.861,10.861,10.861c5.947,0,10.861-4.848,10.861-10.861 V62.319h31.418v29.802c0,5.947,4.848,10.861,10.861,10.861c5.947,0,10.861-4.848,10.861-10.861V62.319h25.923 C364.735,62.319,369.067,66.651,369.067,72.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M21.657,145.261v213.527c0,5.43,4.331,9.762,9.762,9.762h327.37c5.43,0,9.762-4.331,9.762-9.762 V145.261H21.657z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.378,
    y: 166.917,
    style: {
      fill: "#56ACE0"
    },
    width: 303.515,
    height: 179.911
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M358.788,40.663H332.8V10.861C332.8,4.913,327.952,0,321.939,0c-5.947,0-10.861,4.848-10.861,10.861 v29.802h-31.418V10.861C279.661,4.913,274.812,0,268.8,0s-10.861,4.848-10.861,10.861v29.802H132.267V10.861 C132.267,4.913,127.418,0,121.406,0s-10.861,4.848-10.861,10.861v29.802H79.127V10.861C79.127,4.913,74.279,0,68.267,0 S57.406,4.848,57.406,10.861v29.802H31.418C14.093,40.663,0,54.756,0,72.081v286.707c0,17.325,14.093,31.418,31.418,31.418h327.37 c17.325,0,31.418-14.093,31.418-31.418V72.081C390.206,54.756,376.113,40.663,358.788,40.663z M368.549,358.788 c0,5.43-4.331,9.762-9.762,9.762H31.418c-5.43,0-9.762-4.331-9.762-9.762V145.261h346.828v213.527H368.549z M368.549,123.539H21.657 V72.081c0-5.43,4.331-9.762,9.762-9.762h25.988v29.802c0,5.947,4.848,10.861,10.861,10.861s10.861-4.848,10.861-10.861V62.319 h31.418v29.802c0,5.947,4.848,10.861,10.861,10.861s10.861-4.848,10.861-10.861V62.319h126.255v29.802 c0,5.947,4.848,10.861,10.861,10.861c5.947,0,10.861-4.848,10.861-10.861V62.319h31.418v29.802c0,5.947,4.848,10.861,10.861,10.861 c5.947,0,10.861-4.848,10.861-10.861V62.319h25.923c5.43,0,9.762,4.331,9.762,9.762v51.459H368.549z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#194F82"
    },
    d: "M58.505,242.23h21.657c5.947,0,10.861-4.848,10.861-10.861 s-4.848-10.861-10.861-10.861H58.505c-5.947,0-10.861,4.848-10.861,10.861S52.558,242.23,58.505,242.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1",
    style: {
      fill: "#194F82"
    },
    d: "M58.505,293.754h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861H58.505c-5.947,0-10.861,4.848-10.861,10.861C47.709,288.84,52.558,293.754,58.505,293.754z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_2",
    style: {
      fill: "#194F82"
    },
    d: "M58.505,345.212h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861H58.505c-5.947,0-10.861,4.848-10.861,10.861C47.709,340.364,52.558,345.212,58.505,345.212z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_3",
    style: {
      fill: "#194F82"
    },
    d: "M121.406,242.23h21.657c5.947,0,10.861-4.848,10.861-10.861 s-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861S115.459,242.23,121.406,242.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_4",
    style: {
      fill: "#194F82"
    },
    d: "M121.406,293.754h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C110.545,288.84,115.459,293.754,121.406,293.754z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_5",
    style: {
      fill: "#194F82"
    },
    d: "M121.406,345.212h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861S115.459,345.212,121.406,345.212z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_6",
    style: {
      fill: "#194F82"
    },
    d: "M184.242,190.772h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C173.446,185.859,178.295,190.772,184.242,190.772 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_7",
    style: {
      fill: "#194F82"
    },
    d: "M184.242,242.23h21.657c5.947,0,10.861-4.848,10.861-10.861 s-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861S178.295,242.23,184.242,242.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_8",
    style: {
      fill: "#194F82"
    },
    d: "M184.242,293.754h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C173.446,288.84,178.295,293.754,184.242,293.754z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_9",
    style: {
      fill: "#194F82"
    },
    d: "M184.242,345.212h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C173.446,340.364,178.295,345.212,184.242,345.212 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_10",
    style: {
      fill: "#194F82"
    },
    d: "M247.143,190.772H268.8c5.948,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C236.283,185.859,241.196,190.772,247.143,190.772 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_11",
    style: {
      fill: "#194F82"
    },
    d: "M247.143,242.23H268.8c5.948,0,10.861-4.848,10.861-10.861 s-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861S241.196,242.23,247.143,242.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_12",
    style: {
      fill: "#194F82"
    },
    d: "M247.143,293.754H268.8c5.948,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C236.283,288.84,241.196,293.754,247.143,293.754z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_13",
    style: {
      fill: "#194F82"
    },
    d: "M309.463,190.772h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C298.602,185.859,303.515,190.772,309.463,190.772 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_14",
    style: {
      fill: "#194F82"
    },
    d: "M309.463,242.23h21.657c5.947,0,10.861-4.848,10.861-10.861 s-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861S303.515,242.23,309.463,242.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_15",
    style: {
      fill: "#194F82"
    },
    d: "M309.463,293.754h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C298.602,288.84,303.515,293.754,309.463,293.754z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#194F82"
    },
    d: "M58.505,242.23h21.657c5.947,0,10.861-4.848,10.861-10.861 s-4.848-10.861-10.861-10.861H58.505c-5.947,0-10.861,4.848-10.861,10.861S52.558,242.23,58.505,242.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1_1_",
    style: {
      fill: "#194F82"
    },
    d: "M58.505,293.754h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861H58.505c-5.947,0-10.861,4.848-10.861,10.861C47.709,288.84,52.558,293.754,58.505,293.754z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_2_1_",
    style: {
      fill: "#194F82"
    },
    d: "M58.505,345.212h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861H58.505c-5.947,0-10.861,4.848-10.861,10.861C47.709,340.364,52.558,345.212,58.505,345.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_3_1_",
    style: {
      fill: "#194F82"
    },
    d: "M121.406,242.23h21.657c5.947,0,10.861-4.848,10.861-10.861 s-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861S115.459,242.23,121.406,242.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_4_1_",
    style: {
      fill: "#194F82"
    },
    d: "M121.406,293.754h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C110.545,288.84,115.459,293.754,121.406,293.754 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_5_1_",
    style: {
      fill: "#194F82"
    },
    d: "M121.406,345.212h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861S115.459,345.212,121.406,345.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_6_1_",
    style: {
      fill: "#194F82"
    },
    d: "M184.242,190.772h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861 C173.446,185.859,178.295,190.772,184.242,190.772z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_7_1_",
    style: {
      fill: "#194F82"
    },
    d: "M184.242,242.23h21.657c5.947,0,10.861-4.848,10.861-10.861 s-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861S178.295,242.23,184.242,242.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_8_1_",
    style: {
      fill: "#194F82"
    },
    d: "M184.242,293.754h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C173.446,288.84,178.295,293.754,184.242,293.754 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_9_1_",
    style: {
      fill: "#194F82"
    },
    d: "M184.242,345.212h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861 C173.446,340.364,178.295,345.212,184.242,345.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_10_1_",
    style: {
      fill: "#194F82"
    },
    d: "M247.143,190.772H268.8c5.948,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861 C236.283,185.859,241.196,190.772,247.143,190.772z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_11_1_",
    style: {
      fill: "#194F82"
    },
    d: "M247.143,242.23H268.8c5.948,0,10.861-4.848,10.861-10.861 s-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861S241.196,242.23,247.143,242.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_12_1_",
    style: {
      fill: "#194F82"
    },
    d: "M247.143,293.754H268.8c5.948,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C236.283,288.84,241.196,293.754,247.143,293.754 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_13_1_",
    style: {
      fill: "#194F82"
    },
    d: "M309.463,190.772h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861 C298.602,185.859,303.515,190.772,309.463,190.772z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_14_1_",
    style: {
      fill: "#194F82"
    },
    d: "M309.463,242.23h21.657c5.947,0,10.861-4.848,10.861-10.861 s-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861S303.515,242.23,309.463,242.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_15_1_",
    style: {
      fill: "#194F82"
    },
    d: "M309.463,293.754h21.657c5.947,0,10.861-4.848,10.861-10.861 c0-5.947-4.848-10.861-10.861-10.861h-21.657c-5.947,0-10.861,4.848-10.861,10.861C298.602,288.84,303.515,293.754,309.463,293.754 z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6f7f26aeb67baa49f3918a6c82d5a45f.svg";
export { ForwardRef as ReactComponent };